// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"9cfeff1f","249":"0cffb1b4","453":"3a33d629","538":"d3681cac","652":"798912a8","688":"7ad12f1e","704":"4e81bfcc","905":"8090d6ec"}[chunkId] + ".chunk.js";
};